import React from "react";

export default function Map() {
  return (
    <div className="map__wrapper">
      <div className="map__card">
        <a
          href="https://www.google.com/maps/place/Fadeyi,+Lagos/@6.5252435,3.351721,15z/data=!3m1!4b1!4m5!3m4!1s0x103b8db513b7cf2d:0x365cf39990e9e11e!8m2!3d6.5275276!4d3.3620311"
          className="map__card__heading"
        >
          My Location
        </a>
        <iframe
          title="Current Location"
          src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d126839.06821658298!2d3.3488896!3d6.5568768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sng!4v1629662849309!5m2!1sen!2sng"
          style={{ border: 0, height: "300px", width: "100%" }}
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
}
